import { userErrorMessage, type PlayerCurrentGame } from '@wx-weiqi/contracts';
import type { GameStore } from './game-store';

export class CurrentGamesStore {
  private state = {
    games: [] as readonly PlayerCurrentGame[],
    nextCursor: null as string | null,
    pending: false,
    openingGameId: null as string | null,
    error: null as string | null,
  };
  private revision = 0;
  private readonly listeners = new Set<() => void>();
  constructor(private readonly game: Pick<GameStore, 'listCurrentGames' | 'loadGame'>) {}
  readonly snapshot = () => this.state;
  readonly subscribe = (listener: () => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };
  private update(patch: Partial<typeof this.state>) {
    this.state = { ...this.state, ...patch };
    this.listeners.forEach((listener) => listener());
  }
  async load(more = false) {
    if (more && (this.state.pending || this.state.nextCursor === null)) return;
    const revision = ++this.revision;
    const after = more ? this.state.nextCursor : null;
    this.update({ pending: true, error: null, ...(more ? {} : { games: [], nextCursor: null }) });
    try {
      const data = await this.game.listCurrentGames(after);
      if (revision !== this.revision) return;
      const games = [...(more ? this.state.games : []), ...data.games];
      this.update({
        games: [...new Map(games.map((item) => [item.gameId, item])).values()],
        nextCursor: data.nextCursor,
      });
    } catch (error) {
      if (revision === this.revision)
        this.update({ error: userErrorMessage(error, '对局列表加载失败，请重试。') });
    } finally {
      if (revision === this.revision) this.update({ pending: false });
    }
  }
  async enter(gameId: string) {
    if (this.state.openingGameId !== null) return;
    this.update({ openingGameId: gameId, error: null });
    try {
      await this.game.loadGame(gameId);
    } catch (error) {
      this.update({ error: userErrorMessage(error, '进入对局失败，请刷新列表后重试。') });
    } finally {
      this.update({ openingGameId: null });
    }
  }
}
